import PropTypes from 'prop-types'

const MailLink = ({
  hotelName,
  displayId,
  placesId,
  streetAddress,
  city,
  stateCode,
  postalCode,
  countryCode,
  latitude,
  longitude,
  invoiceAddress,
  errorDetail,
  children
}) => {
  const subject = 'Unable to add subaccount - address issue'
  const resolvedError =
    errorDetail ||
    '12113, The provided street address could not be verified. Please submit a valid street address'
  const body = encodeURIComponent(
    ` 
    Hi,

    We have the following details to add but it fails due to address issues.

    "HotelName": ${hotelName},
    "DisplayId": ${displayId ?? ''},
    "PlacesId": ${placesId},
    "StreetAddress": ${streetAddress},
    "City": ${city},
    "StateCode": ${stateCode},
    "PostalCode": ${postalCode},
    "CountryCode": ${countryCode},
    "Latitude": ${latitude},
    "Longitude": ${longitude},
    "Address": ${invoiceAddress},
    Error we get is the following: "${resolvedError}"

    Please update us, once you define this address.
  `
  )

  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={`mailto:911support@bandwidth.com?subject=${subject}&body=${body}`}
    >
      {children}
    </a>
  )
}

MailLink.propTypes = {
  hotelName: PropTypes.string,
  displayId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  placesId: PropTypes.string,
  streetAddress: PropTypes.string,
  city: PropTypes.string,
  stateCode: PropTypes.string,
  postalCode: PropTypes.string,
  countryCode: PropTypes.string,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  invoiceAddress: PropTypes.string,
  errorDetail: PropTypes.string,
  children: PropTypes.node
}

export default MailLink
